<template>
  <div v-if="isDialogShow && popUpData.id" class="container">
    <img class="content" :src="popUpData.pop_up_image" @click="jumpUrl" />
    <!-- 关闭按钮 -->
    <img class="close" :src="closeIcon" alt="" @click="close" />
  </div>
</template>

<script>
import { getGiftFeedbackInfo } from '@/api/giftCenter';
import { reportData } from '@/api/report';

export default {
  name: 'LeadGiftDialog',
  props: {
    pageType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isDialogShow: false, // 引流弹窗是否展示
      closeIcon: '//assets.hzwxbz2.cn/sy/static/img/close.png', // 关闭按钮
      popUpData: {}, // 弹窗数据
    };
  },
  methods: {
    initData() {
      if (!this.pageType) return;

      getGiftFeedbackInfo({
        page_type: this.pageType,
        pop_up_type: 2,
      }).then((res) => {
        const { id } = res.data || {};

        if (id) {
          this.isDialogShow = true;
          this.popUpData = res.data;

          reportData({
            type: 25,
            data_type: 1,
            extend: res.data.id,
          });
        }
      });
    },
    jumpUrl() {
      if (!this.popUpData.url) return;

      reportData({
        type: 25,
        data_type: 2,
        extend: this.popUpData.id,
      });

      setTimeout(() => {
        window.open(this.popUpData.url, '_blank');
      }, 500);
    },
    close() {
      this.isDialogShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 100;
}

.content {
  width: 288px;
  height: 347px;
  position: absolute;
  left: 50%;
  top: 140px;
  transform: translate3d(-50%, 0, 0);
}

.close {
  width: 52px;
  height: 52px;
  object-fit: contain;
  position: absolute;
  top: 500px;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
}
</style>
